module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/exit@1x.png?0.0.53";